<template>
  <div class="align-center d-flex flex-column mb-7">
    <div class="font-weight-semibold">Please enter the code</div>
    <div class="d-flex flex-wrap justify-center">
      <div>We sent an SMS code to this number:</div>
      <div class="font-weight-semibold">+1 {{ phone }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AuthElementsEnterCode",
  props: {
    phone: String,
  },
};
</script>
